var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.666,
    y: 26.666,
    width: 46.6667,
    height: 36.6667,
    fill: "url(#paint0_linear_6853_17468)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0375 34.0019L16.0056 57.1396C16.0006 60.9395 18.9911 64.0189 22.6762 64.0142L57.2989 63.9635C60.9525 63.9568 63.9442 60.8744 63.9515 57.1094L63.9834 33.9718C63.9884 30.1718 60.9979 27.0924 57.3128 27.0972L22.6901 27.1478C19.0195 27.1557 16.0437 30.2195 16.0375 34.0019V34.0019Z",
    stroke: "#353535",
    strokeWidth: 5.27266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 38.8884H63.7485M39.9994 25.998V62.6647",
    stroke: "#353535",
    strokeWidth: 5.27266
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3327 13.334V13.334C37.0146 13.334 39.9993 16.3188 39.9993 20.0007V26.6673H33.3327C29.6508 26.6673 26.666 23.6825 26.666 20.0007V20.0007C26.666 16.3188 29.6508 13.334 33.3327 13.334Z",
    stroke: "#353535",
    strokeWidth: 5.27266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6667 13.334V13.334C50.3486 13.334 53.3333 16.3188 53.3333 20.0007V20.0007C53.3333 23.6825 50.3486 26.6673 46.6667 26.6673H40V20.0007C40 16.3188 42.9848 13.334 46.6667 13.334Z",
    stroke: "#353535",
    strokeWidth: 5.27266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6853_17468",
    x1: 16.666,
    y1: 26.666,
    x2: 100.132,
    y2: 39.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBold);
export default __webpack_public_path__ + "static/media/giftBold.1a98f805ee47829aa039aa82fbd32ecf.svg";
export { ForwardRef as ReactComponent };